import { render } from "./DialogMenu.vue?vue&type=template&id=e0acad3e&bindings={\"choices\":\"props\",\"buttonHandler\":\"options\",\"clickHandler\":\"options\"}"
import script from "./DialogMenu.vue?vue&type=script&lang=js"
export * from "./DialogMenu.vue?vue&type=script&lang=js"

import "./DialogMenu.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script